const SET_DATE_FILTER = 'common/SET_DATE_FILTER';
const SET_UTIL_DATE = 'common/SET_UTIL_DATE';
const SET_PROD_DATE = 'common/SET_PROD_DATE';
const SET_HEALTH_DATE = 'common/SET_HEALTH_DATE';
const SET_TIER_DATE = 'common/SET_TIER_DATE';
const SET_TRENDS_DATE = 'common/SET_TRENDS_DATE';
const SET_OPERATIONS_DATE = 'common/SET_OPERATIONS_DATE';
const SET_IMC_DATE = 'common/SET_IMC_DATE';
const SET_KOWA_DATE = 'common/SET_KOWA_DATE';
const SET_REPORTMINING_DATE = 'common/SET_REPORTMINING_DATE';
const SET_ORDERHISTORY_DATE = 'common/SET_ORDERHISTORY_DATE';
const SET_REPORTING_DATE = 'common/SET_REPORTING_DATE';
const SET_PUNCHOUTHISTORY_DATE = 'common/SET_PUNCHOUTHISTORY_DATE';

export {
    SET_DATE_FILTER,
    SET_UTIL_DATE,
    SET_PROD_DATE,
    SET_HEALTH_DATE,
    SET_TIER_DATE,
    SET_TRENDS_DATE,
    SET_OPERATIONS_DATE,
    SET_IMC_DATE,
    SET_KOWA_DATE,
    SET_REPORTING_DATE,
    SET_REPORTMINING_DATE,
    SET_ORDERHISTORY_DATE,
    SET_PUNCHOUTHISTORY_DATE
};